









import { defineComponent } from "@vue/composition-api";
import { AbsBox, Icon } from "@ui";

export default defineComponent({
	components:{
		Icon,
		AbsBox,
	},
});
